<template>
  <div class="boxContent vif-container">
    <div>
      <div class="vif-header">
        <h1 class="title">Vehicle Information Form</h1>
        <p v-if="complete === 0">
          Please provide us with accurate information; we use this to customize
          your new unit to your vehicle. If you provide us inaccurate
          information, your unit will not function properly, and you may be
          subject to a $100 reprogram charge. Questions call 888-875-2958.
        </p>
        <p v-if="complete === 1">
          This vehicle has already been verified. Thank you.
        </p>
      </div>
      <div v-if="complete === 0">
        <div class="infos_block col">
          <div v-if="this.vehicle != ''">
            <p class="form-error" v-if="!formData.vin">
              We still need your vehicle VIN.
            </p>
            <p class="form-error" v-if="!formData.transmission">
              We still need the type of Transmission for your vehicle.
            </p>
            <p class="form-error" v-if="!formData.drive">
              We still need the Wheel Drive for your vehicle.
            </p>
            <p class="form-error" v-if="!formData.size">
              We still need your vehicle Engine Size.
            </p>
            <p class="form-error" v-if="!formData.number">
              We still need your Part Number from the Computer you are replacing
              in your vehicle.
            </p>
          </div>
          <div id="infoCol">
            <div class="form-row">
              <div class="form">
                <span class="vifTxtMain">*Name:</span>
                <input
                  name="Name"
                  type="text"
                  class="textbox"
                  :class="invalidFields.Name ? 'error' : ''"
                  id="Name"
                  v-model="formData.name"
                  @blur="validateFieldOnFocus"
                />
                <span class="help-block form-error" v-if="invalidFields.Name"
                  >Name is a required field.</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Email:</span>
                <input
                  name="email"
                  type="text"
                  class="textbox validate"
                  :class="invalidFields.email ? 'error' : ''"
                  id="email"
                  v-model="formData.email"
                  @blur="validateFieldOnFocus"
                />
                <span class="help-block form-error" v-if="invalidFields.email"
                  >Email Address is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Type of Unit Ordered:</span>
                <select
                  name="unit"
                  id="unit"
                  class="selectbox validate"
                  :class="invalidFields.unit ? 'error' : ''"
                  v-model="formData.unit"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="unit.id"
                    v-for="(unit, id) in this.units"
                    v-bind:key="id"
                  >
                    {{ unit.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.unit"
                  >Type of Unit Ordered is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Make:</span>
                <select
                  name="make"
                  id="make"
                  class="selectbox validate"
                  :class="invalidFields.make ? 'error' : ''"
                  v-model="formData.make"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="make.id"
                    v-for="(make, id) in makes"
                    v-bind:key="id"
                  >
                    {{ make.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.make"
                  >Make is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Model:</span>
                <select
                  name="model"
                  id="model"
                  class="selectbox validate"
                  :class="invalidFields.model ? 'error' : ''"
                  v-model="formData.model"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="model.id"
                    v-for="(model, id) in models"
                    v-bind:key="id"
                  >
                    {{ model.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.model"
                  >Model is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">*Year:</span>
                <select
                  name="year"
                  id="year"
                  class="selectbox validate"
                  :class="invalidFields.year ? 'error' : ''"
                  v-model="formData.year"
                  @blur="validateFieldOnFocus"
                >
                  <option value="">Please select</option>
                  <option
                    :value="year.id"
                    v-for="(year, id) in this.years"
                    v-bind:key="id"
                  >
                    {{ year.name }}
                  </option>
                </select>
                <span class="help-block form-error" v-if="invalidFields.year"
                  >Year is a required field</span
                >
              </div>
              <div class="form">
                <span class="vifTxtMain">Manufacture Date</span>
                <select
                  name="manufacture_year"
                  id="manufacture_year"
                  class="selectbox"
                  v-model="formData.manufacture_year"
                >
                  <option
                    :value="manufacture_year.value"
                    v-for="(manufacture_year) in this.manufacture_years"
                    v-bind:key="manufacture_year.value"
                  >
                    {{ manufacture_year.label }}
                  </option>
                </select>
                <select
                  name="manufacture_month"
                  id="manufacture_month"
                  class="selectbox"
                  v-model="formData.manufacture_month"
                  v-if="formData.manufacture_year>0"
                >
                  <option
                    :value="manufacture_month.value"
                    v-for="(manufacture_month) in this.manufacture_months"
                    v-bind:key="manufacture_month.value"
                  >
                    {{ manufacture_month.label }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">Do you have to pass California Smog?</span>
                <select
                  name="smog"
                  id="smog"
                  class="selectbox"
                  v-model="formData.smog"
                >
                  <option
                    :value="smog.value"
                    v-for="(smog) in this.smogs"
                    v-bind:key="smog.value"
                  >
                    {{ smog.label }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">VIN</span>
                <input
                  name="vin"
                  type="text"
                  class="textbox"
                  id="vin"
                  v-model="formData.vin"
                />
              </div>
              <div class="form">
                <span class="vifTxtMain">Transmission:</span>
                <select
                  name="transmission"
                  id="transmission"
                  class="selectbox validate"
                  v-model="formData.transmission"
                >
                  <option value="">Please select</option>
                  <option
                    :value="transmission.id"
                    v-for="(transmission, id) in this.transmissions"
                    v-bind:key="id"
                  >
                    {{ transmission.name }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">Wheel Drive:</span>
                <select
                  name="drive"
                  id="drive"
                  class="selectbox validate"
                  v-model="formData.drive"
                >
                  <option value="">Please select</option>
                  <option
                    :value="drive.id"
                    v-for="(drive, id) in this.drives"
                    v-bind:key="id"
                  >
                    {{ drive.name }}
                  </option>
                </select>
              </div>
              <div class="form">
                <span class="vifTxtMain">Engine Size</span>
                <input
                  name="size"
                  type="text"
                  class="textbox"
                  id="size"
                  v-model="formData.size"
                />
              </div>
              <div class="form" v-if="parts.length == 0">
                <span class="vifTxtMain">Part Number from Computer You are Replacing in Your Car <a href="/partnumber" target="_blank">How do I find my part number?</a></span>
                <input
                  name="number"
                  type="text"
                  class="textbox"
                  id="number"
                  v-model="formData.number"
                />
              </div>

              <div class="form" v-if="parts.length > 0">
                <span class="vifTxtMain">Module P/N <a href="/part-number" target="_blank">How do I find my part number?</a></span>
                <select
                    name="number"
                    type="text"
                    class="textbox"
                    id="number"
                    v-model="formData.number"
                >
                  <option value="">Please select</option>
                  <option
                      :value="part.value"
                      v-for="(part, id) in this.parts"
                      v-bind:key="id"
                  >
                    {{ part.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="place_btn">
            <a
              href="#"
              class="save"
              title="Save"
              @click="validAllFields($event)"
              >Save</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vehicle_id: {
      type: String
    },
    order_id: {
      type: String
    },
  },
  created() {
    // manufacture_years
    const startYear = 1990
    const currentYear = new Date().getFullYear()
    this.manufacture_years = []
    for (let i = startYear; i <= currentYear; i++) {
      this.manufacture_years.push({ value: i, label: i })
    }
    this.manufacture_years.push({ value: 0, label: 'Not known' })

    axios.get('/api/vehicle/makes').then((res) => {
      this.makes = res.data
    })
    this.vehicle = this.vehicle_id
    if (this.vehicle_id != '') {
      axios.get('/api/vehicle/' + this.vehicle_id).then((res) => {
        this.formData.name = res.data.name
        this.formData.email = res.data.email
        this.formData.make = res.data.make_id
        this.formData.model = res.data.model_id
        this.formData.vin = res.data.vin
        this.formData.size = res.data.engine_size
        this.formData.number = res.data.part_number

        this.complete = parseInt(res.data.complete)

        if (res.data.smog === undefined || res.data.smog === null) {
          this.formData.smog = 2
        } else {
          this.formData.smog = parseInt(res.data.smog)
        }
        if (res.data.manufacture_date === undefined || res.data.manufacture_date === null) {
          this.formData.manufacture_year = 0
          this.formData.manufacture_month = 1
        } else {
          let manus = res.data.manufacture_date.split('.')
          this.formData.manufacture_year = manus[0]
          this.formData.manufacture_month = manus[1]
        }

        this.formData.unit = this.units.filter(
          (mk) => mk.name == res.data.unit_type
        )[0].id
        this.formData.transmission = res.data.transmission
          ? this.transmissions.filter(
              (mk) => mk.name == res.data.transmission
            )[0].id
          : ''
        this.formData.drive = res.data.wheel_drive
          ? this.drives.filter((mk) => mk.name == res.data.wheel_drive)[0].id
          : ''
        this.formData.year = res.data.year
      }).catch(responseErrors => {
        this.complete = 0;
      });
    } else {
      this.complete = 0;
    }

    this.formParts();
  },
  computed: {
    formMake() {
      return this.formData.make
    },
    formModel() {
      return this.formData.model
    },
  },
  watch: {
    formMake: function (val) {
      this.years = null
      if (val) {
        axios.get('/api/vehicle/model/' + val).then((res) => {
          this.models = res.data
        })
      }
    },

    formModel: function (val) {
      if (val) {
        axios.get('/api/vehicle/model-year/' + val).then((res) => {
          this.years = res.data
        })
      }
    },
  },
  data() {
    return {
      complete: -1,
      makes: null,
      models: null,
      years: null,
      yearValue: '',
      invalidFields: {},
      vehicle: '',
      parts: [],
      formData: {
        name: '',
        email: '',
        unit: '',
        make: '',
        model: '',
        year: '',
        vin: '',
        transmission: '',
        drive: '',
        size: '',
        number: '',
        smog: 2,
        manufacture_year: 0,
        manufacture_month: 1,
      },
      smogs: [
        { value: 2, label: 'Not known' },
        { value: 0, label: 'No' },
        { value: 1, label: 'Yes' },
      ],
      manufacture_years: [],
      manufacture_months: [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
      ],
      units: [
        { id: 1, name: 'ECM' },
        { id: 2, name: 'PCM' },
        { id: 3, name: 'TCM' },
        { id: 4, name: 'FICM' },
        { id: 5, name: 'TIPM' },
      ],
      transmissions: [
        { id: 1, name: 'manual' },
        { id: 2, name: 'automatic' },
      ],
      drives: [
        { id: 1, name: '2WD two wheel drive' },
        { id: 2, name: '4WD four wheel drive' },
        { id: 3, name: 'AWD all wheel drive' },
      ],
      notRequiredInputs: ['vin', 'transmission', 'drive', 'size', 'number', 'smog', 'manufacture_year', 'manufacture_month'],
    }
  },
  methods: {
    async validAllFields(e, data = null, masterKey = null) {
      e.preventDefault()

      if (!data) {
        data = this.formData
      }

      let notRequired = this.notRequiredInputs

      for (let key in data) {
        let needCheck = true
        notRequired.forEach((field) => {
          let fieldArr = field.split('|')
          let valueForField = ''
          let nextField = ''
          if (fieldArr.length > 1) {
            valueForField = fieldArr[1].split(':')[1]
            nextField = fieldArr[1].split(':')[0]
          }

          if (fieldArr.length === 1 && key == fieldArr[0]) {
            needCheck = false
          }

          // if this item contains next field and it's false we need to ignore field
          if (
            fieldArr.length === 2 &&
            key == fieldArr[0] &&
            !this.formData[nextField]
          ) {
            needCheck = false
          }

          if (
            valueForField &&
            key == fieldArr[0] &&
            this.formData[nextField] !== valueForField
          ) {
            needCheck = false
          }
        })
        if (!needCheck) continue
        if (typeof data[key] == 'object') {
          return this.validAllFields(e, data[key], key)
        }
        if (masterKey) {
          if (!this.formData[masterKey][key]) {
            this.$set(
              this.invalidFields,
              this.mappingModelToErrors(masterKey + '.' + key),
              true
            )
          }
        } else {
          if (!this.formData[key]) {
            this.$set(this.invalidFields, this.mappingModelToErrors(key), true)
          }
        }
      }

      let canCreateOrder = true
      for (let key in this.invalidFields) {
        if (this.invalidFields[key]) {
          return false
        }
      }
      return this.vifCreate()
    },
    vifCreate() {
      let makeName = this.makes.filter((mk) => mk.id == this.formData.make)[0]
        .name
      let modelName = this.models.filter(
        (md) => md.id == this.formData.model
      )[0].name
      let yearValue = this.years.filter((yr) => yr.id == this.formData.year)[0]
        .name
      let unitValue = this.units[this.formData.unit - 1].name
      let transmissionValue = this.formData.transmission
        ? this.transmissions[this.formData.transmission - 1].name
        : ''
      let driveValue = this.formData.drive
        ? this.drives[this.formData.drive - 1].name
        : ''
      let manufacture_date = ''
      if (this.formData.manufacture_year > 0) {
        manufacture_date = this.formData.manufacture_year + '.' + this.formData.manufacture_month
      } else {
        manufacture_date = 'null'
      }

      localStorage.removeItem('items')
      axios
        .post('/api/vif-mail', {
          ...this.formData,
          vehicle: this.vehicle,
          makeName,
          modelName,
          yearValue,
          unitValue,
          transmissionValue,
          driveValue,
          manufacture_date,
          query_order_id: this.order_id,
        })
        .then((response) => {
          if (!response.data.done) {
            window.location.href = '/vehicle_information_form/' + response.data.vehicle_id
          } else {
            window.location.href = '/vif-thankyou?check=1'
          }
        })
        .catch((responseErrors) => {
          if (responseErrors.response) {
            if (responseErrors.response.status === 301) {
              return (location.href = responseErrors.response.data.redirect)
            }
          }
        })
    },
    mappingModelToErrors(key) {
      let mapping = {
        name: 'Name',
      }
      return mapping[key] || key
    },
    validateFieldOnFocus(e) {
      let validType = 'checkEmpty'
      switch (e.target.id) {
        case 'pass':
          validType = 'checkMatches'
          break
      }
      return this[validType](e)
    },
    checkEmpty(e) {
      if (!e.target.value) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
    checkMatches(e) {
      let neededField = e.target.getAttribute('data-match')
      if (!e.target.value || e.target.value !== this.formData[neededField]) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
    formParts: function () {
      let order_id = this.order_id
      if (order_id) {
        axios.get('/api/vif/get-part-number/' + order_id).then((res) => {
          if (res.data.status == 'OK'){
            if( res.data.data.length > 1 ) {
              this.parts = res.data.data
            }
          }
        })
      }
    },
  },
}
</script>
